<div class="flex-column h-100">
  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    <odx-content-box-header>
      <h5
        class="odx-title-5"
        i18n="@@kvmConfiguration.selectCategory.header"
        data-testid="kvmConfiguration.selectCategory.header"
      >
        Select category
      </h5>
    </odx-content-box-header>

    <form [formGroup]="categoryForm">
      <odx-radio-group formControlName="selectedCategory">
        <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
          @for (category of categories; track category) {
            <app-picture-card
              class="overflow-hidden"
              [imageUrl]="category.imageId"
              [title]="getCategoryLabel(category.deviceType)"
              [isSelected]="categoryForm.value.selectedCategory === category.deviceType"
              (click)="onCategoryClicked(category)"
            >
              <odx-radio-button (click)="$event.stopPropagation()" [value]="category.deviceType" i18n="@@global.select"
                >Auswählen</odx-radio-button
              >
            </app-picture-card>
          }
        </div>
      </odx-radio-group>
    </form>
  </odx-content-box>
</div>
